import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18ffdc30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "t3" }, "Cargar factura", -1))
const _hoisted_2 = { class: "p2 p-mt-2 text-light-gray" }
const _hoisted_3 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toast = _resolveComponent("toast")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_toast),
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.invoiceData.level) + " " + _toDisplayString(_ctx.copies.uploadInvoiceForm.comision) + " " + _toDisplayString(_ctx.invoiceData.kind) + " - " + _toDisplayString(_ctx.setParsedDate(_ctx.invoiceData.payoutDate)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        questions: _ctx.questions,
        rules: _ctx.rules,
        buttonLabel: _ctx.buttonLabels,
        loadingSubmit: _ctx.loadingSubmit,
        onOnSubmit: _ctx.handleSubmit,
        onOnCancel: _ctx.handleCloseForm
      }, null, 8, ["questions", "rules", "buttonLabel", "loadingSubmit", "onOnSubmit", "onOnCancel"])
    ])
  ]))
}